var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('media-element',{attrs:{"media":_vm.media,"lightbox":_vm.lightbox}})}
var staticRenderFns = []

export { render, staticRenderFns }